import React, { useEffect, useState } from 'react'
import { useAppTranslation } from '../../hooks'
import { getAppBarState } from 'src/store'
import { WorkstationProductsEnum } from 'src/core/models'
import { CustomAutocomplete } from './CustomAutoComplete'

export const WorkstationProductSelect = ({
  disabled,
  onChange,
  value,
  getDefaultValue,
  disableClearable = false,
  selectDefaultProduct = true,
}: {
  disabled?: boolean
  value: WorkstationProductsEnum | undefined
  onChange?: (value: WorkstationProductsEnum | null) => void
  getDefaultValue: (value?: WorkstationProductsEnum | null) => void
  disableClearable?: boolean
  selectDefaultProduct?: boolean
}) => {
  const { label } = useAppTranslation()
  const { userEnterprise } = getAppBarState().appState
  const products = (userEnterprise && userEnterprise.products) || []

  // Create options array with value and label
  const productOptions = React.useMemo(() => {
    if (products.length === 0) {
      return [{ value: WorkstationProductsEnum.HORSE_RACES, label: label(WorkstationProductsEnum.HORSE_RACES) }]
    }
    return products.map(product => ({ value: product, label: label(product) }))
  }, [products, label])

  // Auto-select first product when products are available and no value is set
  useEffect(() => {
    if (selectDefaultProduct && productOptions.length > 0 && !value && getDefaultValue) {
      const firstProduct = productOptions[0].value
      getDefaultValue(firstProduct)
    }
  }, [selectDefaultProduct, productOptions, value, getDefaultValue])

  // Find current selected option based on external value
  const selectedOption = React.useMemo(() => {
    if (!value) return null
    return productOptions.find(option => option.value === value) || null
  }, [value, productOptions])

  return (
    <CustomAutocomplete
      data={productOptions}
      value={selectedOption}
      onChangeValue={(selectedOption, action) => {
        if (onChange) {
          // Pass the selected value or null when clearing
          onChange(selectedOption?.value || null)
        }
      }}
      placeholder={label('PRODUCTO')}
      keyLabel="label"
      label={label("PRODUCTO")}
      disableClearable={disableClearable}
      disabled={disabled}
    />
  )
}
